import * as React from 'react';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom'; // For navigation
import Sheet from '@mui/joy/Sheet';
import CssBaseline from '@mui/joy/CssBaseline';
import Typography from '@mui/joy/Typography';
import FormControl from '@mui/joy/FormControl';
import FormLabel from '@mui/joy/FormLabel';
import Input from '@mui/joy/Input';
import Button from '@mui/joy/Button';
import { collection, query, where, getDocs } from 'firebase/firestore';
import { db } from'../../../api/firebase';

export default function LoginPage() {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate(); // Hook for navigation

  const handleLogin = async (event) => {
    event.preventDefault();
    setError('');

    try {
      // Query Firestore to find a document with the matching username and password
      const companyCollection = collection(db, 'admin');
      const q = query(companyCollection, where('username', '==', username), where('password', '==', password));
      const querySnapshot = await getDocs(q);

      if (!querySnapshot.empty) {
        // Login successful
        const userData = querySnapshot.docs[0].data();
        console.log('Login successful! User data:', userData);

        // Store login state in localStorage
        localStorage.setItem('isLoggedIn', 'true');
        localStorage.setItem('username', username);

        // Redirect to Travel Page
        navigate('/sofia/admin/dashbord');
      } else {
        // No matching document found
        setError('Invalid username or password.');
      }
    } catch (error) {
      setError('An error occurred during login.');
      console.error('Error during login:', error);
    }
  };

  return (
    <main>
      <CssBaseline />
      <Sheet
        sx={{
          width: 300,
          mx: 'auto',
          my: 4,
          py: 3,
          px: 2,
          display: 'flex',
          flexDirection: 'column',
          gap: 2,
          borderRadius: 'sm',
          boxShadow: 'md',
        }}
        variant="outlined"
      >
        <div>
          <Typography level="h4" component="h1">
            <b>Welcome!</b>
          </Typography>
          <Typography level="body-sm">Sign in to continue.</Typography>
        </div>
        <FormControl>
          <FormLabel>Username</FormLabel>
          <Input
            name="username"
            type="text"
            placeholder="Enter your username"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
          />
        </FormControl>
        <FormControl>
          <FormLabel>Password</FormLabel>
          <Input
            name="password"
            type="password"
            placeholder="Enter your password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
        </FormControl>
        {error && <Typography color="danger">{error}</Typography>}
        <Button sx={{ mt: 1 }} onClick={handleLogin}>Log in</Button>
      </Sheet>
    </main>
  );
}




// import * as React from 'react';
// import { useColorScheme } from '@mui/joy/styles';
// import Sheet from '@mui/joy/Sheet';
// import CssBaseline from '@mui/joy/CssBaseline';
// import Typography from '@mui/joy/Typography';
// import FormControl from '@mui/joy/FormControl';
// import FormLabel from '@mui/joy/FormLabel';
// import Input from '@mui/joy/Input';
// import Button from '@mui/joy/Button';
// import Link from '@mui/joy/Link';
// import Select from '@mui/joy/Select';
// import Option from '@mui/joy/Option';

 

// export default function loginPage() {
//   return (
//     <main>
//        <CssBaseline />
//       <Sheet
//         sx={{
//           width: 300,
//           mx: 'auto', // margin left & right
//           my: 4, // margin top & bottom
//           py: 3, // padding top & bottom
//           px: 2, // padding left & right
//           display: 'flex',
//           flexDirection: 'column',
//           gap: 2,
//           borderRadius: 'sm',
//           boxShadow: 'md',
//         }}
//         variant="outlined"
//       >
//         <div>
//           <Typography level="h4" component="h1">
//             <b>Welcome!</b>
//           </Typography>
//           <Typography level="body-sm">Sign in to continue.</Typography>
//         </div>
//         <FormControl>
//           <FormLabel>Email</FormLabel>
//           <Input
//             // html input attribute
//             name="email"
//             type="email"
//             placeholder="johndoe@email.com"
//           />
//         </FormControl>
//         <FormControl>
//           <FormLabel>Password</FormLabel>
//           <Input
//             // html input attribute
//             name="password"
//             type="password"
//             placeholder="password"
//           />
//         </FormControl>
//         <Button sx={{ mt: 1 /* margin top */ }}>Log in</Button>

//       </Sheet>
//     </main>
//   );
// }

 